import Page from './page'

export default class System extends Page
  @defaults =
    debug: false
    name: 'Modulor__Page__System'
